'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagAlAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.8111e-05 0L28 3.59863e-06V20H-6.10352e-05L2.8111e-05 0Z",
          fill: "#EE343C"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 4L9.99999 5.33334L12.6667 6.66667V8H11.3333L8.66666 6.66667L7.33333 8L9.99999 9.33333L7.99999 10.6667L11.3333 11.3333L8.66666 13.3333H9.99999L12.6667 12.6667L11.3333 14.6667H13.3333L14 16.6667L14.6667 14.6667H16.6667L15.3333 12.6667L18 13.3333H19.3333L16.6667 11.3333L20 10.6667L18 9.33333L20.6667 8L19.3333 6.66667L16.6667 8H15.3333V6.66667C16.2222 6.22223 18 5.33334 18 5.33334L16 4L14 6L12 4Z",
          fill: "#262626"
        }
      )
    ]
  }
);
const VpFlagAlAsset = forwardRef(FlagAlAsset);

export { VpFlagAlAsset as default };
